import SurveySettingsRoutes from './settings';
import SurveyReportsRoutes from './reports';

const SurveyRoutes = {
  ...SurveySettingsRoutes,
  ...SurveyReportsRoutes,
};
export default SurveyRoutes;
